<template>
    <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M48.3275 4.62216C48.1788 4.49328 47.9683 4.46361 47.7898 4.54634L6.78977 23.5463C6.61307 23.6282 6.5 23.8053 6.5 24V26.5C6.5 26.6148 6.53953 26.7262 6.61194 26.8153L19.6119 42.8153C19.7608 42.9985 20.0176 43.0527 20.2277 42.9451L63.2277 20.9451C63.3949 20.8596 63.5 20.6877 63.5 20.5V18C63.5 17.855 63.437 17.7171 63.3275 17.6222L48.3275 4.62216Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7 24L20 40M20 40L63 18M20 40V43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGShelf',
};
</script>

<style scoped lang="scss">

</style>
